import AppVersion from "./AppVersion";

export const APP_DOWNLOAD_NAME_PREFIX = "gp-a-v";

const appVersions: AppVersion[] = [
    {
        version: "5.0.0",
        changes: [
            "Posibilidad de transferencia de artículos entre repartidores, con funcionalidades de aceptar y rechazar solicitaciones de transferencia.",
        ],
    },
    {
        version: "5.0.1",
        changes: [
            "Adiciona número de orgen en la lista de órdenes.",
        ],
    },
];

export default appVersions;
